// extracted by mini-css-extract-plugin
export var alertIcon = "_ta-0";